// extracted by mini-css-extract-plugin
export default {"PoweredBy":"PoweredBy_PoweredBy__fDlZd","Image":"PoweredBy_Image__Wc9uX"};